import React from 'react'
import clsx from 'clsx'

export const GridCellSize = {
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
  Nine: 9,
  Ten: 10,
  Eleven: 11,
  Twelve: 12,
  Full: 12,
  Half: 6,
  Third: 3,
  Quarter: 4,
  Auto: 'auto',
  Shrink: 'shrink'
}

export function GridCell (props) {
  const {
    children,
    auto,
    shrink,
    blockY,
    smallBlockY,
    mediumBlockY,
    largeBlockY,
    blockX,
    smallBlockX,
    mediumBlockX,
    largeBlockX,
    blockContainer,
    smallBlockContainer,
    mediumBlockContainer,
    largeBlockContainer,
    small = 0,
    smallOffSet = 0,
    medium = 0,
    mediumOffSet = 0,
    large = 0,
    largeOffSet = 0,
    className,
    hide = false,
    onClick,
    style
  } = props

  if (hide) {
    return null
  }

  let classes = clsx(
    `cell`,
    small && `small-${small}`,
    medium && `medium-${medium}`,
    large && `large-${large}`,
    smallOffSet && `small-offset-${smallOffSet}`,
    mediumOffSet && `medium-offset-${mediumOffSet}`,
    largeOffSet && `large-offset-${largeOffSet}`,
    auto === true && 'auto',
    shrink === true && 'shrink',
    blockY === true && 'cell-block-y',
    smallBlockY === true && 'small-cell-block-y',
    mediumBlockY === true && 'medium-cell-block-y',
    largeBlockY === true && 'large-cell-block-y',
    blockX === true && 'cell-block-x',
    smallBlockX === true && 'small-cell-block-x',
    mediumBlockX === true && 'medium-cell-block-x',
    largeBlockX === true && 'large-cell-block-x',
    blockContainer === true && 'cell-block-container',
    smallBlockContainer === true && 'small-cell-block-container',
    mediumBlockContainer === true && 'medium-cell-block-container',
    largeBlockContainer === true && 'large-cell-block-container',
    className
  )

  return <div style={style} className={classes} onClick={onClick}>
    {children}
  </div>
}
